import { motion } from 'framer-motion'
import { cn } from '../../utils/cn'

const features = [
  {
    id: 1,
    title: 'NFC Technology',
    subtitle: 'Tap & Connect',
    description: 'Make payments and share information with a simple tap.',
    image: '/images/feature-nfc.png',
    cta: 'Learn More',
    href: '#technology',
  },
  {
    id: 2,
    title: 'Easy Application',
    subtitle: 'Apply in Minutes',
    description: 'Professional-looking nails without the salon visit.',
    image: '/images/feature-application.png',
    cta: 'How It Works',
    href: '#howto',
  },
  {
    id: 3,
    title: 'Custom Designs',
    subtitle: 'Express Yourself',
    description: 'Choose from dozens of stunning designs or create your own.',
    image: '/images/feature-designs.png',
    cta: 'Browse Designs',
    href: '#products',
  },
]

function FeatureCard({ feature, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: index * 0.15 }}
      className="group relative overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 bg-bg-tertiary">
        <img
          src={feature.image}
          alt={feature.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          onError={(e) => {
            e.target.style.display = 'none'
          }}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
      </div>

      {/* Content */}
      <div className="relative h-[400px] lg:h-[500px] flex flex-col justify-end p-8">
        <p className="text-xs uppercase tracking-[0.2em] text-white/70 mb-2">
          {feature.subtitle}
        </p>
        <h3 className="text-2xl font-serif font-medium text-white mb-3">
          {feature.title}
        </h3>
        <p className="text-sm text-white/80 mb-6 max-w-xs">
          {feature.description}
        </p>
        <a
          href={feature.href}
          className={cn(
            'inline-flex items-center justify-center',
            'w-fit px-6 py-3',
            'bg-white text-primary',
            'text-xs font-medium uppercase tracking-wider',
            'hover:bg-white/90 transition-colors duration-300'
          )}
        >
          {feature.cta}
        </a>
      </div>
    </motion.div>
  )
}

export default function FeatureCards() {
  return (
    <section id="collections" className="bg-bg-primary">
      <div className="grid lg:grid-cols-3">
        {features.map((feature, index) => (
          <FeatureCard key={feature.id} feature={feature} index={index} />
        ))}
      </div>
    </section>
  )
}
